import AccessRequestStatuses from './AccessRequestStatuses';

export default AccessRequestStatuses;
